export const PAYOUT_STATUS = [
  'BLOCKED',
  'TO_SEND',
  'PENDING',
  'ERROR',
  'PAID',
] as const;
export type PayoutStatus = (typeof PAYOUT_STATUS)[number];

export enum PayoutStatusEnum {
  BLOCKED = 'BLOCKED',
  TO_SEND = 'TO_SEND',
  PENDING = 'PENDING',
  ERROR = 'ERROR',
  PAID = 'PAID',
}

export type Bill = {
  readonly id: number;
  readonly hotelName: string;
  readonly reference: string;
  readonly commissionAmount: number;
  readonly totalAmount: number;
  readonly payoutAmount: string;
  readonly createdAt: string;
  readonly updatedAt: string;
  readonly fromDate: string;
  readonly toDate: string;
  readonly provider: string;
  readonly status: string;
  readonly errorMessage: string | undefined;
  readonly payoutId: number | undefined;
};

export enum BillStatus {
  TO_GENERATE = 'TO_GENERATE',
  PENDING = 'PENDING',
  GENERATED = 'GENERATED',
  SENT = 'SENT',
  ERROR = 'ERROR',
}
